import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IRunRouteExecutorProps } from './IRunRouteExecutorProps';
import { readActionReasonOptions } from '@organisms/actions/ActionReason/actionReason';
import { RunRouteExecutorModal } from '@organisms/actions/docExecutors/RunRoute/RunRouteExecutorModal';

export const RunRouteExecutor = createDocModalExecutor<IRunRouteExecutorProps>({
    modal: RunRouteExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, cancelButtonText, modalSize, completeHandler }) => {
        const hasMessage = typeof action.options?.message === 'string' && action.options.message.trim().length > 0;

        return {
            docId: objId ?? '',
            actionKey: action.key ?? '',
            title: action.options?.title ?? '',
            message: action.options?.message ?? '',
            // Без текста-вопроса кнопка называется «Выполнить», а не «ОК»
            okButtonText: action.options?.okButtonText ?? (hasMessage ? 'ОК' : 'Выполнить'),
            cancelButtonText,
            modalSize,
            completeHandler,
            ...readActionReasonOptions(action.options),
        };
    },
});
